import FullSenderName from '../senders/components/FullSenderName';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { chooseAssignmentSystemMessage } from './operators/chooseAssignmentSystemMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignmentLabel = ({
  activeAgentId,
  assignorSender,
  assigneeSender,
  isLoading
}) => {
  if (isLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      "data-test-id": "skeleton-text",
      inlineSize: "200px",
      use: "on-shade"
    });
  }
  const assignorName = assignorSender && /*#__PURE__*/_jsx(FullSenderName, {
    sender: assignorSender
  });
  const assigneeName = assigneeSender && /*#__PURE__*/_jsx(FullSenderName, {
    sender: assigneeSender
  });
  return chooseAssignmentSystemMessage({
    assignorSender,
    assigneeSender,
    activeAgentId,
    assignorName,
    assigneeName
  });
};
AssignmentLabel.displayName = 'AssignmentLabel';
export default AssignmentLabel;